'use strict';

import RWDX, {rwdxComponents} from './rwdx/RWDX';
import cookies from './cookies';
import blogScripts from './blogScripts';
import RWDXReviews from "./rwdx/components/RWDXReviews";
import stickyNav from "./stickyNav";
import menuTabs from "./menuTabs";
import cateringResponsive from "./cateringResponsive";

rwdxComponents.init();
RWDX.init();

cookies();

if (document.querySelector(".our-menu")) {
    menuTabs();
}

window.addEventListener('resize', stickyNav)
stickyNav()

if (document.getElementById('blog-page')) {
    blogScripts();
}

if (document.querySelector(".review__body")) {
    RWDXReviews();
}

const navButton = document.querySelector('button[data-open-nav]');

navButton?.addEventListener("click", () => {
    document.body.setAttribute(
        'data-nav-open',
        (document.body.dataset.navOpen !== "true").toString()
    )

    if (document.body.dataset.navOpen === "true") {
        if (document.body.getAttribute('data-nav-sticky') !== 'true') return
        document.body.setAttribute('data-nav-sticky', 'false')
        document.body.style.marginTop = null
    }

});

const fillingContainer = document.querySelector(".filling-container");
const showMoreBtn = document.querySelector(".show-more-btn");

showMoreBtn?.addEventListener("click", () => {

    let open = fillingContainer.getAttribute("data-open");

    if (!open) {
        fillingContainer.setAttribute("data-open", "true");
        showMoreBtn.innerHTML = "Show less";
        return;
    }

    fillingContainer.setAttribute("data-open", (open === "true" ? "false" : "true"));
    showMoreBtn.innerHTML = open === "true" ? "Show more" : "Show less";
})

if (document.querySelector('div[data-menu="platter-a"]')) {
    cateringResponsive()
}